import { useSegment } from '@telialt/utils/src/segment';

import { ESHOP_MUTATION_KEY } from '../../model';
import { apiUpdateCartInsurance } from '../../store/api';
import { useCartQuery } from '../queries/useCartQuery';
import { useMutationWithCartRefresh } from './useMutationWithCartRefresh';

export const useInsuranceMutation = () => {
    const segment = useSegment();
    const { cartId } = useCartQuery();
    const { isPending, error, mutate } = useMutationWithCartRefresh(
        async (insuranceSelected: boolean) => {
            const { data: cart } = await apiUpdateCartInsurance(segment, { cartId }, insuranceSelected);

            return cart;
        },
        {
            mutationKey: [ESHOP_MUTATION_KEY.UPDATE_INSURANCE],
        },
    );

    return {
        mutateInsurance: mutate,
        insuranceIsLoading: isPending,
        insuranceError: error,
    };
};
